import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslations } from "../../providers/useTranslations";
import { RibbonBadge } from "../RibbonBadge";
export const LeftBadge = ({ isFreeTrialProduct, label }) => {
    const { __ } = useTranslations();
    if (isFreeTrialProduct) {
        return _jsx(RibbonBadge, { tier: "none", text: __("product.badge.freeTrial") });
    }
    if (label) {
        return _jsx(RibbonBadge, { tier: "none", text: label });
    }
    return _jsx("span", {});
};
//# sourceMappingURL=LeftBadge.js.map